import { Plus, Check } from 'lucide-react';
import { useQuote } from '@/context/QuoteContext';
import { QUOTE } from '@/constants/testIds';

export default function AddToQuoteButton({ product, variant = 'default' }) {
  const { add, hasItem, openDrawer } = useQuote();
  const inCart = hasItem(product.id);

  const onClick = () => {
    if (inCart) {
      openDrawer();
    } else {
      add(product, 1);
    }
  };

  const compact = variant === 'compact';

  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={QUOTE.addBtn(product.id)}
      aria-label={inCart ? `${product.name} — in your quote list` : `Add ${product.name} to your quote`}
      className={`inline-flex items-center gap-1.5 uppercase tracking-[0.22em] transition-colors border ${
        inCart
          ? 'border-[var(--mw-primary)] text-[var(--mw-primary)] bg-[var(--mw-primary)]/10 hover:bg-[var(--mw-primary)] hover:text-white'
          : 'border-white/15 text-white/80 hover:border-white hover:text-white'
      } ${compact ? 'text-[10px] px-2.5 py-1.5' : 'text-[11px] px-3.5 py-2'}`}
    >
      {inCart ? <Check size={compact ? 10 : 12} /> : <Plus size={compact ? 10 : 12} />}
      {inCart ? 'In quote' : 'Add to quote'}
    </button>
  );
}
